import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMysqlComponent } from './simple-icons-mysql.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMysqlComponent ],
    exports:      [ SimpleIconsMysqlComponent ],
    bootstrap:    []
})
export class SimpleIconsMysqlModule {}
